import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Lock } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { PayDebtAction } from "@/components/Molecules";
import { formatPersianNumber } from "@/lib/format/persian";
import type { CommissionDebtModalProps } from "./CommissionDebtModal.types";
import * as styles from "./CommissionDebtModal.styles";

export type { CommissionDebtModalProps } from "./CommissionDebtModal.types";

export const CommissionDebtModal = memo(function CommissionDebtModal({
  open,
  canPayDebt,
  messageFa,
  outstandingDebt,
  onClose,
}: CommissionDebtModalProps) {
  const { t } = useTranslation("commission");
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} slotProps={{ paper: { sx: styles.paper } }}>
      <DialogTitle sx={styles.header}>
        <Box sx={styles.iconWrap}>
          <Lock size={22} variant="Bold" color={theme.palette.error.main} />
        </Box>
        <Typography sx={styles.title}>{t("debtModal.title")}</Typography>
      </DialogTitle>

      <DialogContent sx={styles.content}>
        <Typography sx={styles.message}>{messageFa ?? t("debtModal.defaultMessage")}</Typography>
        {outstandingDebt !== undefined ? (
          <Typography sx={styles.dataSafeText}>
            {t("debtModal.amount", { amount: formatPersianNumber(outstandingDebt) })}
          </Typography>
        ) : null}
      </DialogContent>

      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} color="secondary">
          {t("actions.close")}
        </Button>
        <PayDebtAction canPayDebt={canPayDebt} />
      </DialogActions>
    </Dialog>
  );
});
